var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKulturBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "kultur",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.21 172.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "a777ce4f-feb8-4a9c-a7c5-9884dbf5d967",
    "data-name": "border",
    d: "M66.15.25H152.4V16.74h5.73v3.6h7.94V69.51H193v84.21h-39.5a50.87,50.87,0,0,0-2.31,8.33c-.53,3.56-2.22,7.39-8.88,6.89s-2.47-5-2.71-7.81a82,82,0,0,0-1.59-8.52H62.06s-5.27,2.59-6.2,3.71,1.08,10.21,0,11.46-7.48,3.78-8.07,3.63-18.15,1.5-19.32,0-2.2-12.31-3.67-13.56-9,3.17-13.24,3.27c-1.34,0-8.1-1.28-8-6.6s5.8-9.44,4.59-10-5.35-.82-5.35-.82v-7.79l2.44-1.54.38-20s-5.65-5-5.35-7.28,5.35-5,5.35-5L5.46,28l18.19-2.82.28-3.84L37.4,20.9l.31,3.34L65.78,20Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKulturBorder);
export default __webpack_public_path__ + "static/media/kultur-border.c2744fc3.svg";
export { ForwardRef as ReactComponent };